<template>
  <div class="message-history-filter">
    <div layout="layout">
      <select-form
        class="mr-x1"
        :label="type.label"
        :icon="type.icon"
        :value="type.value"
        :options="type.options"
        :placeholder="type.placeholder"
        :onChange="onChangeType"
      ></select-form>
      <select-form
        class="mr-x1"
        :label="message.label"
        :icon="message.icon"
        :value="message.value"
        :options="listMessage"
        :placeholder="message.placeholder"
        :onChange="onChangeMessage"
      ></select-form>
      <select-form
        class="mr-x1"
        :label="loseReason.label"
        :icon="loseReason.icon"
        :value="loseReason.value"
        :options="listLoseReason"
        :placeholder="loseReason.placeholder"
        :onChange="onChangeLoseReason"
      ></select-form>
      <select-form
        class="mr-x1"
        :label="isResponder.label"
        :icon="isResponder.icon"
        :value="isResponder.value"
        :options="isResponder.options"
        :placeholder="isResponder.placeholder"
        :onChange="onChangeIsResponder"
      ></select-form>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/client/assets/scss/variables.scss' as *;

.message-history-filter {
  .el-input__inner {
    height: $spacing-unit * 4;
  }

  .el-input {
    width: $spacing-unit * 18;
  }
}
</style>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import SelectForm from '@/client/components/_atoms/select_form'
import { INSTANTWIN_LOSE_REASON } from '@/client/constant'
import { useTwitterInstantwinMessageHistoryStore } from '@/client/store/useTwitterInstantwinMessageHistoryStore'

export default defineComponent({
  components: {
    SelectForm
  },
  data() {
    return {
      type: {
        label: '種別',
        value: null as string | null,
        icon: 'folder-multiple-outline',
        placeholder: '種別',
        options: [
          { label: '指定なし', value: null },
          { label: '当選', value: 'win' },
          { label: '落選', value: 'lose' }
        ]
      },
      message: {
        value: null as number | null,
        label: 'メッセージ',
        icon: 'email',
        placeholder: 'メッセージ'
      },
      loseReason: {
        value: null as string | null,
        label: '落選となった理由',
        icon: 'magnify-close',
        placeholder: '落選となった理由'
      },
      isResponder: {
        value: -1,
        label: '回答者',
        icon: 'clipboard-check',
        placeholder: '回答者',
        options: [
          { label: '指定なし', value: -1 },
          { label: '回答フラグあり', value: 1 },
          { label: '回答フラグなし', value: 0 }
        ]
      }
    }
  },
  computed: {
    ...mapState(useTwitterInstantwinMessageHistoryStore, {
      params: state => state.params,
      listMessage: state => {
        const defaultOption: { label: string; value: number | null }[] = [{ label: '指定なし', value: null }]
        let messages = state.messages
        if (state.params.filterType) {
          messages = messages.filter(message => {
            return message.messageType === state.params.filterType
          })
        }

        const listMessages = messages.map(message => ({
          label: message.name,
          value: message.id
        }))

        return defaultOption.concat(listMessages)
      }
    }),
    listLoseReason() {
      const defaultOption: { label: string; value: string | null }[] = [{ label: '指定なし', value: null }]

      if (this.type.value === 'win') return defaultOption

      const loseReasons = Object.keys(INSTANTWIN_LOSE_REASON).map(v => ({
        label: INSTANTWIN_LOSE_REASON[v],
        value: v
      }))

      return defaultOption.concat(loseReasons)
    }
  },
  methods: {
    ...mapActions(useTwitterInstantwinMessageHistoryStore, ['fetchHistoryList', 'setHistoryParams']),

    onChangeType(value: string | null) {
      if (this.params.filterType === value) return

      this.type.value = value
      this.message.value = null
      this.loseReason.value = null

      this.setHistoryParams({ filterType: value, filterMessage: null, filterLoseReason: null, pagingNo: 1 })
    },

    onChangeMessage(value: number | null) {
      if (this.params.filterMessage === value) return

      this.message.value = value

      this.setHistoryParams({ filterMessage: value, pagingNo: 1 })
    },

    onChangeLoseReason(value: string | null) {
      if (this.params.filterLoseReason === value) return

      this.loseReason.value = value

      this.setHistoryParams({ filterLoseReason: value, pagingNo: 1 })
    },

    onChangeIsResponder(value: number) {
      if (this.params.filterResponder === value) return

      this.isResponder.value = value

      this.setHistoryParams({ filterResponder: value, pagingNo: 1 })
    }
  }
})
</script>
